import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PersistentStorageService {

  constructor() { }

  setLocalStorage(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  getLocalStorage(key: string): any {
    return localStorage.getItem(key) || null;
  }

  removeLocalStorage(key: string) {
    localStorage.removeItem(key);
  }
}
